import Reveal from "@/components/Reveal";

const PILLARS = [
  { n: "01", title: "Finance", desc: "Accounting, treasury, payroll & FP&A run to your close calendar." },
  { n: "02", title: "Governance", desc: "Board cadence, controls, audit readiness & compliance calendar." },
  { n: "03", title: "Technology", desc: "Stack rollout, delivery pods, security & toolchain operations." },
  { n: "04", title: "Strategic Execution", desc: "Leadership hiring, OKRs and scale playbooks that actually land." },
];

export default function Pillars() {
  return (
    <section className="border-b border-line" data-testid="pillars-strip">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-px bg-line sm:grid-cols-2 lg:grid-cols-4">
        {PILLARS.map((p, i) => (
          <Reveal key={p.n} delay={i * 0.1} className="bg-paper">
            <div
              className="group h-full p-8 transition-colors duration-300 hover:bg-white"
              data-testid={`pillar-${p.n}`}
            >
              <p className="font-mono text-xs tracking-[0.2em] text-gold">{p.n}.</p>
              <h3 className="mt-4 font-serif text-2xl tracking-tight">{p.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-ink/60">{p.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
